import { render } from "./PurchaseOrder.vue?vue&type=template&id=6c138eab&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js"

import "./PurchaseOrder.vue?vue&type=style&index=0&id=6c138eab&scoped=true&lang=css"
import "./PurchaseOrder.vue?vue&type=style&index=1&id=6c138eab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c138eab"]])

export default __exports__